<!-- NOTE Navbar -->
<nav class="navbar navbar-expand-lg navbar-light bg-white py-3">
  <div class="g-padx w-100 d-flex justify-content-between">
    <a class="navbar-brand" [routerLink]="['/home']" [fragment]="'home'">
      <img src="./assets/img/project/stays-connect-logo.svg" [alt]="appName + ' Logo'" class="me-2" />
    </a>

    <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse mobile-menu" [ngbCollapse]="isMenuCollapsed" id="navbarSupportedContent"
      *ngIf="propertyUrlSegment !== '/account' && propertyUrlSegment !== '/property' && propertyUrlSegment !== '/management' && propertyUrlSegment !== '/wallet';else property_header">
      <ul class="navbar-nav mb-2 mb-lg-0 w-100 justify-content-end">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" [fragment]="'about-us'" [routerLinkActive]="['active']">{{ 'About us' | translate }}</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" [fragment]="'benefits'" [routerLinkActive]="['active']">{{
            'Benefits' | translate }}</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" [fragment]="'faq'" [routerLinkActive]="['active']">{{ 'FAQs' |
            translate }}</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" [fragment]="'contact'" [routerLinkActive]="['active']">{{
            'Support' | translate }}</a>
        </li>

        <li (click)="openModalXl(languageModal)" class="nav-item d-flex align-items-center" style="cursor: pointer;">
          <img [src]="websiteCountry?.['country-flag']" alt="translation" class="" />
          <div class="nav-link ps-2">{{websiteCountry?.Language}}</div>
        </li>

        <li class="nav-item d-flex align-items-center" *ngIf="!loggedInUser">
          <button class="cta primary-bkg md py-1" [routerLink]="['/account/login']">Login</button>
        </li>

        <li class="nav-item dropdown" *ngIf="loggedInUser" ngbDropdown>
          <div class="d-flex align-items-center" ngbDropdownToggle type="button" style="cursor: pointer;">
            <img src="./assets/img/project/icons/avatar.svg" alt="avatar" class="me-2" />
            <div class="d-flex flex-column justify-content-start px-2">
              <span class="text-lowercase">{{ email_address }}</span>
            </div>
          </div>

          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <button class="dropdown-item" type="button" (click)="goToPropertyListing()">Property Overview</button>
            <button class="dropdown-item" type="button" (click)="logout()">Logout</button>
          </div>
        </li>

      </ul>
    </div>

    <ng-template #property_header>
      <div class="collapse navbar-collapse mobile-menu menu-profile" [ngbCollapse]="isMenuCollapsed"
        id="navbarSupportedContent">
        <ul class="navbar-nav mb-2 mb-lg-0 w-100 justify-content-end">

          <li (click)="openModalXl(languageModal)" class="nav-item d-flex align-items-center" style="cursor: pointer;">
            <img [src]="websiteCountry['country-flag']" alt="translation" class="" />
            <div class="nav-link ps-2">{{websiteCountry.Language}}</div>
          </li>

          <li class="nav-item">
            <img src="./assets/img/project/icons/bell_icon.svg" alt="translation" class="" />
          </li>

          <li class="nav-item">
            <div class="d-flex align-items-center">
              <img src="./assets/img/project/icons/avatar.svg" alt="translation" class="">
              <div class="d-flex flex-column justify-content-start px-2">
                <p style="font-size: 0.8rem;" class="mb-0">{{ legalNameOfProperty }}
                </p>
                <span class="text-lowercase">{{ email_address }}</span>
              </div>
              <span class="dropdown" placement="bottom-start" ngbDropdown>
                <span style="color: black;" data-bs-toggle="dropdown" ngbDropdownToggle></span>
                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                  <button class="dropdown-item" type="button" (click)="goToPropertyListing()">Property Overview</button>
                  <button class="dropdown-item" type="button" [routerLink]="['/management/reservation']">Reservations</button>
                  <button class="dropdown-item" type="button" [routerLink]="['/management/my-calendar']">My Calendar</button>
                  <button class="dropdown-item" type="button" [routerLink]="['/management/user-profile']">User Management</button>
                  <button class="dropdown-item" type="button" (click)="logout()">Logout</button>
                </div>
              </span>
            </div>
          </li>
        </ul>
        <ng-container *ngIf="propertyUrlSegment == '/management'">
          <ul class="navbar-nav mb-2 mb-lg-0 w-100 managmement-menu">
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['/management/reservation-details']"
                [routerLinkActive]="['active']">Reservation</a>
            </li>
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['/management/my-calendar']" [routerLinkActive]="['active']">My
                calendar</a>
            </li>
            <!-- <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['']" [routerLinkActive]="['active']">Guest List</a>
            </li>
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['']" [routerLinkActive]="['active']">Promotion</a>
            </li> -->
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['/property/rooms']" [routerLinkActive]="['active']">Room Management</a>
            </li>
            <!-- <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['']" [routerLinkActive]="['active']">Analytics</a>
            </li>
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['']" [routerLinkActive]="['active']">User management</a>
            </li> -->
            <!-- <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLink]="['']" [routerLinkActive]="['active']">Settings</a>
            </li> -->
            <li class="nav-item sub-menu-item d-flex align-items-center justify-content-center">
              <a class="nav-link" [routerLinkActive]="['active']">Help center</a>
              <div class="dropdown" placement="bottom-start">
                <div ngbDropdown>
                  <span data-bs-toggle="dropdown" ngbDropdownToggle></span>
                  <div class="dropdown-menu p-3 contact-menu" ngbDropdownMenu>
                    <div class="d-flex align-items-start gap-2 mb-2">
                      <i class="bi bi-whatsapp text-success fs-5"
                         role="img" aria-label="Official WhatsApp Icon" title="Official WhatsApp Icon"></i>
                      <div class="d-flex flex-column">
                        <span class="fw-semibold">WhatsApp (Official):</span>
                        <a href="https://wa.me/2349088195089" target="_blank" rel="noopener">+234 908 819 5089</a>
                      </div>
                    </div>
                    <div class="d-flex align-items-start gap-2 mb-2">
                      <i class="bi bi-telephone-fill text-primary fs-5"
                         role="img" aria-label="Call Icon" title="Call Icon"></i>
                      <div class="d-flex flex-column">
                        <span class="fw-semibold">Call Only (Support Line):</span>
                        <a href="tel:+2347059504877">+234 705 950 4877</a>
                        <a href="tel:+2347059504997">+234 705 950 4997</a>
                      </div>
                    </div>
                    <div class="d-flex align-items-start gap-2">
                      <i class="bi bi-envelope-fill text-secondary fs-5" role="img" aria-label="Email Icon" title="Email Icon"></i>
                      <div class="d-flex flex-column">
                        <span class="fw-semibold">Email:</span>
                        <a href="mailto:support@staysconnect.com">support&#64;staysconnect.com</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item d-flex align-items-center justify-content-center">
              <a class="nav-link" (click)="logout()">Logout</a>
            </li>
          </ul>
        </ng-container>
      </div>
    </ng-template>
  </div>
</nav>

<!-- NOTE Content -->
<ng-content></ng-content>

<!--Language Selection Modal-->
<ng-template #languageModal>
  <div class="laguage-selection-wrap px-4 py-4">
    <div class="title">Select your language</div>
    <!-- <div class="desc">Where applicable, prices will be converted to—and shown in—the currency you select.
      The currency you pay in may differ based on your reservation, and a service fee may also apply.
    </div> -->

    <div class="language-wrap">
      <div *ngFor="let language of languages" (click)="selectLanguage(language)" class="language">
        <img [src]="language['country-flag']">
        <div class="details">
          <div class="name">{{language.Language}}</div>
          <div class="code">{{language["ISO-code"]}}</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>